import { useState } from 'react';
import { Sheet } from '../components/Sheet.jsx';
import { useCreateLeistung, useLeistungsarten } from '../hooks/data.js';
import { useToast } from '../state/toast.jsx';
import { addDays, dayLabel, hours, isoDate } from '../lib/format.js';

const DAUERN = [0.25, 0.5, 1, 1.5, 2, 3, 4, 6, 8];

/** Zeit nachtragen mit Datum und beliebiger Dauer. */
export function NachtragSheet({ nr, defaults, onClose }) {
  const arten = useLeistungsarten();
  const create = useCreateLeistung(nr);
  const toast = useToast();
  const [datum, setDatum] = useState(isoDate());
  const [stunden, setStunden] = useState(1);
  const [beschreibung, setBeschreibung] = useState(defaults.beschreibung);
  const [leistungsartId, setLeistungsartId] = useState(defaults.leistungsartId);
  const [error, setError] = useState('');

  const tage = [0, -1, -2, -3].map((n) => addDays(isoDate(), n));

  const submit = async () => {
    setError('');
    const body = { datum, stunden, beschreibung, leistungsartId };
    try {
      const r = await create.mutateAsync({ ...body, label: `${hours(stunden)} ${beschreibung || 'Arbeitszeit'} (${dayLabel(datum)})` });
      toast(r.queued
        ? { text: `Vorgemerkt: ${hours(stunden)} am ${dayLabel(datum)} wird automatisch gebucht, sobald Netz da ist`, long: true }
        : { text: `${hours(stunden)} am ${dayLabel(datum)} gebucht` });
      onClose();
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <Sheet title="Zeit nachtragen" onClose={onClose}>
      <div className="stack" style={{ gap: 8 }}>
        <span className="label">Datum</span>
        <div className="wrapchips">
          {tage.map((d) => <button key={d} className={`chip accent${datum === d ? ' on' : ''}`} onClick={() => setDatum(d)}>{dayLabel(d)}</button>)}
          <input type="date" className="input" style={{ width: 170, height: 48 }} value={datum} max={isoDate()} onChange={(e) => e.target.value && setDatum(e.target.value)} aria-label="Anderes Datum" />
        </div>
      </div>
      <div className="stack" style={{ gap: 8 }}>
        <span className="label">Dauer</span>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(5, minmax(0, 1fr))', gap: 6 }}>
          {DAUERN.map((h) => <button key={h} className={`chip accent tn${stunden === h ? ' on' : ''}`} style={{ height: 46, borderRadius: 12, padding: 0 }} onClick={() => setStunden(h)}>{hours(h).replace(' h', '')}</button>)}
        </div>
      </div>
      <label className="field">
        <span className="label">Tätigkeit</span>
        <input className="input" value={beschreibung} onChange={(e) => setBeschreibung(e.target.value)} maxLength={500} />
      </label>
      <label className="field">
        <span className="label">Leistungsart</span>
        <select className="input" value={leistungsartId} onChange={(e) => setLeistungsartId(Number(e.target.value))}>
          {(arten.data ?? []).map((a) => <option key={a.id} value={a.id}>{a.titel}</option>)}
        </select>
      </label>

      {error && <p className="error" role="alert">{error}</p>}
      <button className="btn lg block" onClick={submit} disabled={create.isPending}>
        {create.isPending ? 'Wird gebucht …' : `${hours(stunden)} buchen`}
      </button>
    </Sheet>
  );
}
